import React, { useEffect, useState } from "react";
import { Button, Box } from "@mui/material";
import FormField from "../FormComponent/FormField/FormField";
import styles from './practitioner.module.css'
import { useForm } from 'react-hook-form';
import { axiosProxyInstance } from "../../utils/request";
import cogoToast from "cogo-toast";

import * as yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';

const validationSchema = yup.object({
    accessibleAccess: yup.string().required('Accessible access selection is required'),
});

const Accessible = ({ sectionData, details }) => {

    const [defaultValues, setDefaultValues] = useState(null);
    const form = useForm({
        resolver: yupResolver(validationSchema),
        mode: "onBlur",
    });
    const { register, handleSubmit, control, formState: { errors, isDirty }, reset } = form;
    const allFields = sectionData.fields;
    const currentUserId = localStorage.getItem("LPCurrentUserId");

    const accessibleAccessField = allFields.find(field => field.id === "accessibleAccess");
    useEffect(() => {
        if (details) {
            const resData = {
                accessibleAccess: details?.data?.accessible_access,
            };
            reset(resData);
            setDefaultValues(resData);
        }
    }, [details, reset]);

    const onSubmit = async (data) => {
        const payload = {
            btn_submit: true,
            listings: [
                {
                    listing_id: details?.ID,
                    title: details?.post_title,
                    address_1: details?.data.address_1,
                    postcode: details?.data.postcode,
                    telephone_1: details?.data?.phone?.raw,
                    specialization: (Object.values(details.data.services || {})),
                    treatments: Object.values(details.data.treatments || {}),
                    provideruid: currentUserId,
                    accessible_access: data.accessibleAccess,
                    uid: currentUserId
                }
            ]
        };
        try {
            const res = await axiosProxyInstance.post('/signup/2/', payload);
            cogoToast.success("Accessible Access Updated Successfully!");
        } catch (err) {
            console.error("Submission failed:", err);
        }
    }

    return (
        <Box>
            <form onSubmit={handleSubmit(onSubmit)}>

                <Box className='margin-top-15'>
                    <Box style={{ flex: "1" }}>
                        <FormField
                            field={accessibleAccessField}
                            register={register}
                            control={control}
                            errors={errors}
                        />
                        <Box className={styles.submitButtonContainer}>
                            <Button
                                disabled={!isDirty}
                                className={styles.primaryButton}
                                size="large"
                                type="submit"
                            >
                                Save Changes
                            </Button>
                            <Button
                                disabled={!isDirty}
                                className={styles.secondaryButton}
                                size="large"
                                onClick={() => reset(defaultValues)}
                            >
                                Cancel
                            </Button>
                        </Box>
                    </Box>
                </Box>
            </form>
        </Box>
    )
}
export default Accessible